import React, { PureComponent } from 'react';
import styled from 'styled-components';

import sortBy from 'lodash/sortBy';

const IssuesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
  font-size: 14px;
`;

const Issue = styled.div`
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.75rem;
  margin-bottom: -1px;
`;

class IssuesTab extends PureComponent {
  render() {
    const { relationshipsByType, id } = this.props;

    return (
      <IssuesWrapper>
        {
          sortBy(relationshipsByType.filter(r => r.producer === id), (rel) => rel.created_at).map((rel) => {
            return <Issue>{rel.consumerElement.name}</Issue>
          })
        }
      </IssuesWrapper>
    );
  }
}

export default IssuesTab;



// WEBPACK FOOTER //
// ./src/components/IssuesTab/IssuesTab.js